module.exports = __webpack_public_path__ + "img/phone-screen-it.e7cfea27.png";